import { VerifyPayeeCheckResponseCode } from '@seapoint/server/enums';
import { PayeeCheckView } from '../../types/entity-types';
import { isVopPayeeCheckDowngrade } from './is-vop-payee-check-downgrade';

type IsPayeeCheckWarningRequiredArgs = {
  previousCheck?: PayeeCheckView;
  newCode: VerifyPayeeCheckResponseCode;
};

export const isPayeeCheckWarningRequired = ({ previousCheck, newCode }: IsPayeeCheckWarningRequiredArgs) => {
  if (!previousCheck) {
    return true;
  }

  return isVopPayeeCheckDowngrade({ previousCheck, newCode });
};
